import React from 'react';
import './myAccount.scss';

/**
 * Props:
 * - endDate: string (formatted end date)
 */
/**
 * @param {{ endDate: string }} props
 */
const FISACoolingOffCancellationMessage = ({ endDate }) => (
    <span className="my-account__fisa-cancellation-message my-account__fisa-cancellation-message--margin-bottom">
        You're still within the 14-day cancellation period, ending at <strong>23:59</strong> on <strong>{endDate}</strong>.
    </span>
);

export default FISACoolingOffCancellationMessage;
